
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';
import Select from "react-select";

const Rep_ledger = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [onceRun, setOnceRun] = useState(false);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [filterLocationType, setFilterLocationType] = useState("O");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [filterFromDate, setFilterFromDate] = useState(new Date());
    const [filterToDate, setFilterToDate] = useState(new Date());
    const [filterViewType, setFilterViewType] = useState("V");
    const [ledgerValue, setLedgerValue] = useState(null);
    const [grpCode, setGrpCode] = useState('0');
    const [accCode, setAccCode] = useState('0');
    const [accountType, setAccountType] = useState('');
    const [accountName, setAccountName] = useState('');
    const [filterReportType, setFilterReportType] = useState('L');
    const [ledgerName, setLedgerName] = useState("");
    const [filterformat, setFilterFormat] = useState("T");
    const [filterAllDataType, setFilterAllDataType] = useState("A");

    const [vgParentGrpCode, setVgParentGrpCode] = useState({ value: 0, label: "Select" });
    const [vgParentGrpList, setVgParentGrpList] = useState([]);
    const [srchParentGrp, setSrchParentGrp] = useState({ value: 0, label: "All" });
    const [grpAccArray, setGrpAccArray] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_LEDGER'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    Common.callApi(Common.apiVoucher, [sid, "allgroupjson"], result => {
                        setVgParentGrpList(JSON.parse(result));
                    });
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }
    const handleGenerate = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if ((filterReportType === "L" && ledgerValue === null)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ledgerValue === null ? "Select Ledger" : '')
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (Common.dateYMD(filterFromDate) < startDate || Common.dateYMD(filterToDate) > endDate) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (Common.dateYMD(filterFromDate) < startDate || Common.dateYMD(filterToDate) > endDate ? "Date should be within financial year" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (filterFromDate > filterToDate) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = setMsgText("From date should be less than To date");
            setMsgBox(true);
            return;
        } else {
            const obj = {
                fromDate: Common.dateYMD(filterFromDate),
                fromDateDMY: Common.dateDMY(filterFromDate),
                toDate: Common.dateYMD(filterToDate),
                toDateDMY: Common.dateDMY(filterToDate),
                accCode: accCode,
                grpCode: grpCode,
                locationCode: locationCode,
                filterLocationType: filterLocationType,
                ledgerName: ledgerName,
                locationType: filterLocationType,
                filterViewType: filterViewType,
                filterformat: filterformat,
                filterAllDataType: filterAllDataType,
                parentGroupCode: srchParentGrp.value,
                filterReportType: filterReportType,
                lineno: 1,
            }
            if (filterReportType == "G" && filterViewType === "D") {
                setMsgText("Getting Account associated with the group .");
                setMsgBox(true);
                Common.callApi(Common.apiRepLedger, [sid, "getgroupaccount", JSON.stringify(obj)], result => {
                    setGrpAccArray(JSON.parse(result));
                    let groupAccount = JSON.parse(result);
                    setMsgText("Creating Blank Excel.");
                    setMsgBox(true);
                    Common.callApi(Common.apiRepLedger, [sid, "getblankexcelfilename", JSON.stringify(obj)], result => {
                        let filename = JSON.parse(result);
                        obj["filename"] = filename;
                        InsertGrpAccData(groupAccount, obj);
                    });
                });
            } else if (filterViewType === 'D') {
                Common.callDownloadApiPost1(Common.apiRepLedger, "post", [sid, "downloadreport", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiRepLedger, [sid, "viewreport", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });
            }

        }
    }
    async function InsertGrpAccData(groupAccount, obj) {
        let showheaderflag = true;
        for (const row of groupAccount) {
            const tempObj = { ...obj };
            tempObj["accCode"] = row["mvli_srno"];
            tempObj["grpCode"] = row["mvg_srno"];
            tempObj["showHeader"] = showheaderflag;
            try {
                setMsgText("Generating Ledger for : " + row["mvg_srno"] + " " + row["mvli_srno"] + " " + row["mvli_ledger_name"]);
                setMsgBox(true);
                obj["lineno"] = await insertData(tempObj);
                showheaderflag = false;
            } catch (error) {
                console.error("API call failed for:", tempObj["accCode"], error);
            }
        }
        Common.callDownloadApiPost1(Common.apiRepLedger, "post", [sid, "downloadreport", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray([result]));
            setMsgBox(true);
        });

    }
    function insertData(tempObj) {
        return new Promise((resolve, reject) => {
            Common.callApi(Common.apiRepLedger, [sid, "insertgrpaccdata", JSON.stringify(tempObj)], result => {
                try {
                    resolve(JSON.parse(result));
                } catch (e) {
                    reject(e);
                }
            });
        });
    }

    const handleLedgerValue = (value) => {
        setLedgerValue(value);
        const account = value.id.split('^');
        setGrpCode(account[1]);
        setAccCode(account[2]);
        setLedgerName(account[3]);
        setAccountType(account[4]);
        setAccountName(account[3]);
    }
    const handleLocationType = (e) => {
        setLedgerValue(null);
        setAccCode('0');
        setGrpCode('0');
        setLedgerName('');
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }
    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Report Ledger</h3>
                    </Col>
                </Row>
                <Row>&nbsp; </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterLocationType} onChange={handleLocationType}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterLocationType === 'A' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Data Type<span className="text-danger">*</span></Form.Label>
                                <Form.Select value={filterAllDataType} onChange={e => setFilterAllDataType(e.target.value)}
                                    required>
                                    <option value="A">Consolidated</option>
                                    <option value="S">Location wise</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        : null}
                    {filterLocationType === 'O' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={filterLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeLocation}
                                    isDisabled={branchDisable === "true"}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col></> : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={filterFromDate}
                                onChange={(date) => setFilterFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={filterToDate}
                                onChange={(date) => setFilterToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Row>
                        {
                            /*
                                <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Report Type <span className="text-danger">*</span></Form.Label>
                                <Form.Select value={filterReportType} onChange={e => setFilterReportType(e.target.value)}
                                    isDisabled={true}
                                    required>
                                    <option value="L">Ledger</option>
                                    <option value="G">Group</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                            */
                        }

                        {filterReportType === 'L' ?
                            <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Ledger<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={ledgerValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchLedgerAllowedInactive(search, locationCode)}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLedgerValue}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </> : <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Group</Form.Label>
                                    <Select options={vgParentGrpList} value={srchParentGrp} onChange={v => setSrchParentGrp(v)} />
                                </Form.Group>
                            </Col>}
                    </Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterViewType} onChange={e => setFilterViewType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {(filterViewType === 'D' && filterReportType !== 'G') ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Formatting<span className="text-danger">*</span></Form.Label>
                                <Form.Select value={filterformat} onChange={e => setFilterFormat(e.target.value)}
                                    required>
                                    <option value="T">CSV</option>
                                    <option value="F">Formatted</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
            </Container >
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_ledger
